// Copyright (c) 2022, Comsearch, Inc., All rights reserved

export const SESSION_TIMEOUT_WARNING_NOTIFICATION_ID = 'SESSION_TIMEOUT_WARNING_NOTIFICATION_ID'
